import { PropsWithChildren } from "react";

function GlobalWrapper({ children }: PropsWithChildren<{}>) {
  return <>{children}</>;
}

export default GlobalWrapper;
